import { client } from '@/api/client';

import { replacePathVariables } from './utils/replacePathVariables';

export const getRequest = async <TResponse>(
  path: string,
  pathVariables?: unknown,
  queryParams?: unknown,
  signal?: AbortSignal,
): Promise<TResponse> => {
  const pathWithVariables = replacePathVariables(path, pathVariables);

  return new Promise((resolve, reject) => {
    client
      .get(pathWithVariables, { params: queryParams, signal })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
